/**
 * Value Object: Password
 * Represents a password with validation rules
 */
export class Password {
  private readonly _value: string;

  constructor(password: string) {
    // if (!this.isValid(password)) {
    //   throw new Error('Password must be at least 8 characters long and contain at least one uppercase letter and one lowercase letter');
    // }
    this._value = password;
  }

  get value(): string {
    return this._value;
  }

  // private isValid(password: string): boolean {
  //   // At least 8 characters, one uppercase, one lowercase
  //   const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d@$!%*?&]{8,}$/;
  //   return passwordRegex.test(password);
  // }

  equals(other: Password): boolean {
    return this._value === other._value;
  }

  toString(): string {
    return this._value;
  }
}
